import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PortalShell } from "../components/PortalShell";

export default function PortalVerifyPage() {
  const [search] = useSearchParams();
  const token = search.get("token") || "";
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError("This link is missing a token. Request a new sign-in link.");
      return;
    }
    // Backend handles the 302 redirect to /portal/dashboard + Set-Cookie.
    // Letting the browser follow it as a top-level navigation keeps the
    // cookie set on the right origin.
    window.location.replace(`/api/portal/verify?token=${encodeURIComponent(token)}`);
  }, [token]);

  return (
    <PortalShell narrow>
      <div className="portal-login">
        <div className="portal-login-card" style={{ textAlign: "center" }}>
          <h1>Signing you in…</h1>
          {error
            ? <p className="portal-error" role="alert">{error}</p>
            : <p className="portal-sub on-card" aria-live="polite">Verifying your sign-in link.</p>}
        </div>
      </div>
    </PortalShell>
  );
}
